module.exports = __webpack_public_path__ + "img/how_to_play_bk_w.329783e0.png";